import { createAsyncThunk } from '@reduxjs/toolkit';
import { login } from '../services/api/authService';

export const loginMember = createAsyncThunk(
  'auth/loginMember',
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await login(email, password);
      if (response.error) return rejectWithValue(response.error);
      return response.user; // payload untuk reducer
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
